import React from 'react';

/**
 * A taped print. Shared by records and by whole sections, so a photo sits in
 * the same place and behaves the same way wherever it appears.
 *
 * It used to be draggable — you could pick it up and move it around the page.
 * That cost a pointer-capture dance to tell a click from a drag, and the prize
 * for working it out was a photo somewhere else on the page. Clicking it opens
 * the light table, and that is all it does now.
 */
export default function Print({ photos, alt, caption, onOpen, style, expanded, controls }) {
  if (!photos.length) return null;

  return (
    <figure
      className="print"
      style={style}
      role="button"
      tabIndex={0}
      /* Set only when the print opens a panel rather than the light table, so
         it announces itself the same way the row's title does. */
      aria-expanded={expanded}
      aria-controls={controls}
      onClick={() => onOpen(0)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onOpen(0);
        }
      }}
    >
      <img src={photos[0]} alt={alt} loading="lazy" decoding="async" draggable="false" />
      {caption && <figcaption>{caption}</figcaption>}
    </figure>
  );
}
